import { extractLozenge } from '../common/lozenge';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { getExtensionKey } from '../../state/helpers';
import extractServerAction from './extract-server-action';
import { extractLink } from '@atlaskit/link-extractors';
import { extractPreviewAction } from './actions/extract-preview-action';
import { CardAction } from '../../view/Card/types';
import { canShowAction } from '../../utils/actions/can-show-action';
const toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details) => {
  if (!actionType) {
    return;
  }
  return {
    action: {
      actionType,
      resourceIdentifiers
    },
    providerKey: extensionKey,
    details
  };
};
const extractAction = (response, id) => {
  var _action$dataRetrieval, _action$dataUpdateAct;
  const extensionKey = getExtensionKey(response);
  const data = response === null || response === void 0 ? void 0 : response.data;
  const actions = extractServerAction(data);
  if (!extensionKey || actions.length === 0) {
    return;
  }
  const action = actions.find(item => (item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction' && (item === null || item === void 0 ? void 0 : item.refField) === 'tag');
  if (!action || !action.resourceIdentifiers) {
    return;
  }
  const read = toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataRetrieval = action.dataRetrievalAction) === null || _action$dataRetrieval === void 0 ? void 0 : _action$dataRetrieval.name);
  const url = extractLink(data);
  const previewData = response ? extractPreviewAction(response) : null;
  const details = {
    id,
    url,
    previewData
  };
  const update = toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name, details);
  return read || update ? {
    read,
    update
  } : undefined;
};
const extractState = (response, actionOptions, id) => {
  if (!response || !response.data) {
    return;
  }
  const lozenge = extractLozenge(response === null || response === void 0 ? void 0 : response.data);
  if (!lozenge) {
    return;
  }
  if (!canShowAction(CardAction.ChangeStatusAction, actionOptions) || getBooleanFF('platform.linking-platform.smart-card.disable-jira-status-action')) {
    return lozenge;
  }
  const action = extractAction(response, id);
  return {
    ...lozenge,
    action
  };
};
export default extractState;